import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner, InputGroup } from 'react-bootstrap'
import { Button } from 'reactstrap'
import { message } from 'antd'

import { storeVehicleType } from '../services'
import { handleError } from '../../../helpers'

export default function NewVehicleTypeForm({ reload }) {
	const { handleSubmit, register, formState: { errors }, reset } = useForm({})
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		storeVehicleType(values)
			.then(res => {
				message.success(res.data.message)
				setLoading(false)
				reset()
				reload()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<Form.Group className='form-group'>
					<Form.Label>Código <span className='text-primary'>*</span></Form.Label>
					<Form.Control
						{...register('sku', { required:true })}
						placeholder='Escriba aquí...'
					/>
					{ errors.sku && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Form.Group className='form-group'>
					<Form.Label>Nombre del Tipo de Vehículo <span className='text-primary'>*</span></Form.Label>
					<Form.Control
						{...register('name', { required:true })}
						placeholder='Escriba aquí...'
					/>
					{ errors.name && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Form.Group className='form-group'>
					<Form.Label>Capacidad de Carga <span className='text-primary'>*</span></Form.Label>
					<InputGroup>
						<Form.Control 
							{...register('load_capacity', { required: true })}
							placeholder='Escriba aquí...'
						/>
						<InputGroup.Text>toneladas</InputGroup.Text>
					</InputGroup>
					{ errors.load_capacity && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text>}
				</Form.Group>
				<Form.Group className='form-group'>
					<Form.Label>Tiempo de Descarga <span className='text-primary'>*</span></Form.Label>
					<Form.Control 
						as="select"
						{...register('unload_time', { required:true })}
					>
						<option value="">:: Seleccione ::</option>
						<option value="15">15 minutos</option>
						<option value="30">30 minutos</option>
						<option value="45">45 minutos</option>
						<option value="60">60 minutos</option>
						<option value="90">90 minutos</option>
						<option value="120">2 horas</option>
						<option value="150">2 horas 30 minutos</option>
						<option value="180">3 horas</option>
						<option value="210">3 horas 30 minutos</option>
						<option value="240">4 horas</option>
					</Form.Control>
					{ errors.unload_time && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Button color='primary' type="submit" disabled={loading}>
					{ loading && <Spinner animation='border' size="sm" className='mr-5' /> }
					Crear Nuevo Tipo de Vehículo
				</Button>
			</Form>
		</React.Fragment>
	)
}